import { Result } from "@cartographerio/fp";
import { isFeatureF, isPoint, safePointToNgr, } from "@cartographerio/geometry";
import { hasOptionalKey, isBoolean, isNullable, isObject, isString, } from "@cartographerio/guard";
import { WrtRainfallEnum } from "@cartographerio/inventory-enums";
import { isTimestamp } from "@cartographerio/types";
import { isNumber } from "lodash-es";
function isPartialSiteAttributes(data) {
    return (isObject(data) && hasOptionalKey(data, "wiskiID", isNullable(isString)));
}
export function isPartialData(data) {
    return (isObject(data) &&
        hasOptionalKey(data, "recorded", isNullable(isTimestamp)) &&
        hasOptionalKey(data, "site", isNullable(isFeatureF(isPoint, isPartialSiteAttributes))) &&
        hasOptionalKey(data, "dynamicRiskAssessment", isNullable(isBoolean)) &&
        hasOptionalKey(data, "estimatedLevel", isNullable(isNumber)) &&
        hasOptionalKey(data, "recentRain", isNullable(WrtRainfallEnum.isValue)) &&
        hasOptionalKey(data, "notes", isNullable(isString)));
}
export function dataDescription(data) {
    return Result.guard(isPartialData, "PartialWrtLevelLoggersData")(data).map(data => [
        data.site?.properties?.label,
        data.site?.properties?.wiskiID,
        data.site?.geometry == null ? null : safePointToNgr(data.site.geometry),
    ]
        .filter(x => x != null)
        .join(", "));
}
export function dataGeometry(data) {
    return Result.guard(isPartialData, "PartialWrtLevelLoggersData")(data).map(data => data.site?.geometry ?? null);
}
export function dataTimestamp(data) {
    return Result.guard(isPartialData, "PartialWrtLevelLoggersData")(data).map(data => data.recorded ?? null);
}
export function copyData(data) {
    return Result.guard(isPartialData, "PartialWrtLevelLoggersData")(data).map(data => ({
        ...data,
        recorded: null,
        dynamicRiskAssessment: null,
        estimatedLevel: null,
        recentRain: null,
        notes: null,
    }));
}
//# sourceMappingURL=parts.js.map